/* Launchpad: consent manager — bridges Shopify Customer Privacy API ↔ Consent Mode v2.
   Reads consent, maps it to gtag consent state, dispatches `lp:consent-changed`, and drives
   the consent banner (#lp-consent-banner). Vanilla, no dependencies. See docs/measurement.md. */
(function () {
  function gtag() { (window.dataLayer = window.dataLayer || []).push(arguments); }

  function readConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null;
    return {
      analytics: !!cp.analyticsProcessingAllowed(),
      marketing: !!cp.marketingAllowed(),
      preferences: cp.preferencesProcessingAllowed ? !!cp.preferencesProcessingAllowed() : false,
      sale: cp.saleOfDataAllowed ? !!cp.saleOfDataAllowed() : false
    };
  }

  function apply(state) {
    gtag('consent', 'update', {
      analytics_storage: state.analytics ? 'granted' : 'denied',
      ad_storage: state.marketing ? 'granted' : 'denied',
      ad_user_data: state.marketing ? 'granted' : 'denied',
      ad_personalization: state.marketing ? 'granted' : 'denied'
    });
    document.dispatchEvent(new CustomEvent('lp:consent-changed', { detail: state }));
  }

  var lastFocused = null;
  function banner() { return document.getElementById('lp-consent-banner'); }
  function hideBanner() {
    var b = banner();
    if (b) b.hidden = true;
    if (lastFocused && typeof lastFocused.focus === 'function') { lastFocused.focus(); lastFocused = null; }
  }
  function showBanner() {
    var b = banner();
    if (!b) return;
    b.hidden = false;
    // Move focus into the banner so keyboard users reach the controls; remember where to return.
    lastFocused = document.activeElement;
    var firstBtn = b.querySelector('[data-lp-consent="accept"]');
    if (firstBtn) firstBtn.focus();
  }

  function shouldShowBanner() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.shouldShowBanner === 'function') return cp.shouldShowBanner();
    // Fallback: show if the visitor's country is in the required-opt-in list and no choice yet.
    var cfg = window.LaunchpadConfig || {};
    var regions = (cfg.consentRequiredRegions || '').split(',').map(function (s) { return s.trim().toUpperCase(); });
    return cfg.bannerEnabled && regions.indexOf((cfg.shopCountry || '').toUpperCase()) !== -1;
  }

  function setConsent(grant) {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    var choice = { analytics: grant, marketing: grant, preferences: grant, sale_of_data: grant };
    if (cp && typeof cp.setTrackingConsent === 'function') {
      cp.setTrackingConsent(choice, function () { apply(readConsent() || choice); hideBanner(); });
    } else {
      apply({ analytics: grant, marketing: grant, preferences: grant, sale: grant });
      hideBanner();
    }
  }

  function wireBanner() {
    var b = banner();
    if (!b) return;
    var accept = b.querySelector('[data-lp-consent="accept"]');
    var decline = b.querySelector('[data-lp-consent="decline"]');
    if (accept) accept.addEventListener('click', function () { setConsent(true); });
    if (decline) decline.addEventListener('click', function () { setConsent(false); });
    // ESC dismisses with the privacy-safe default (decline = no tracking).
    b.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !b.hidden) { ev.stopPropagation(); setConsent(false); }
    });
    if (shouldShowBanner()) showBanner(); else hideBanner();
  }

  function init() {
    var initial = readConsent();
    if (initial) apply(initial);
    // Shopify fires this when the visitor sets/changes consent (incl. via Shopify's own banner).
    document.addEventListener('visitorConsentCollected', function () {
      var s = readConsent();
      if (s) { apply(s); hideBanner(); }
    });
    wireBanner();
  }

  // Shopify loads customerPrivacy asynchronously; wait for it (with a short bound).
  function ready() {
    if (window.Shopify && window.Shopify.customerPrivacy) { init(); return; }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (window.Shopify && window.Shopify.customerPrivacy) { clearInterval(iv); init(); }
      else if (tries > 40) { clearInterval(iv); init(); } // ~10s; fall back to banner-only
    }, 250);
  }

  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);
})();
